"use strict";

import angular from "angular";

angular.module("nucont.accounting.company.department", ["nucont.shared"]);
require("./department.routes");
require("./tax/department-tax.routes");
require("./personnel/department-personnel.routes");
require("./financial/department-financial.routes");
require("./accounting/department-accounting.routes");
